module.exports = __webpack_public_path__ + "static/media/Template_25.c7ceb028.png";